import { ref, set, push, update, remove } from 'firebase/database';
import { db } from '../config/firebase';
import { ItineraryItem } from '../types/trip';

export async function addItineraryItem(
  tripId: string,
  item: Omit<ItineraryItem, 'itemId' | 'createdAt'>
): Promise<string> {
  const itemRef = push(ref(db, `trips/${tripId}/itinerary`));
  const itemId = itemRef.key!;
  const fullItem: ItineraryItem = {
    ...item,
    itemId,
    createdAt: Date.now(),
  };
  await set(itemRef, fullItem);
  return itemId;
}

export async function updateItineraryItem(
  tripId: string,
  itemId: string,
  updates: Partial<ItineraryItem>
): Promise<void> {
  await update(ref(db, `trips/${tripId}/itinerary/${itemId}`), updates);
}

export async function deleteItineraryItem(
  tripId: string,
  itemId: string
): Promise<void> {
  await remove(ref(db, `trips/${tripId}/itinerary/${itemId}`));
}

export async function setRsvp(
  tripId: string,
  itemId: string,
  uid: string,
  going: boolean
): Promise<void> {
  await set(ref(db, `trips/${tripId}/itinerary/${itemId}/rsvps/${uid}`), going);
}
